import { Popover } from 'antd';
import { useState } from 'react';
import styles from './ActionGroup.module.scss'

const ActionItem = (props) => {
    const [hover, setHover] = useState(true)
    const [popoverOpen, setPopoverOpen] = useState()
    const isActive = props.selected == props.value
    const isHover = hover == props.value
    const highlight = (isActive || isHover) && !props.disabled
    const icon = !props.useActiveIcon
        ? props.icon
        : (highlight ? props.activedIcon : props.icon)


    const onClick = () => {
        props.onChange && props.onChange(props.value)
        props.onClick && props.onClick()
    }
    return (
        <Popover
            content={props.popover}
            arrow={false}
            placement="bottomLeft"
            open={!!props.popover && popoverOpen}
            onOpenChange={setPopoverOpen}
            overlayClassName={styles.radio_popover}
            overlayStyle={{paddingTop: '10px'}}
        >
            <div
                className={`${styles.radio_warp} ${isActive && styles.radio_warp_checked} ${highlight && styles.radio_warp_highlight} ${props.disabled && styles.radio_warp_disabled}`}
                onClick={() => onClick()}
                onMouseOver={() => setHover(props.value)}
                onMouseOut={() => setHover()}
            >
                <span
                    className={styles.radio_icon}
                    style={{
                        backgroundImage: `url(${icon})`,
                        ...props.iconStyle
                    }}
                ></span>
                <span className={styles.radio_label}>{props.label}</span>
            </div>
        </Popover>
    )
}

export default ActionItem
